<template>
  <v-menu ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field v-model="rangeText" :label="label" :placeholder="placeholder" prepend-icon="mdi-calendar" readonly v-on="on"/>
    </template>
    <v-date-picker v-model="dates" multiple no-title scrollable>
      <v-spacer/>
      <v-btn text color="success" @click="menu = false">Cancel</v-btn>
      <v-btn text color="success" @click="$refs.menu.save(dates)">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
  export default {
    name: 'dates-field',
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Array,
      },
      label: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      }
    },
    data:() => ({
      menu: false,
      dates: []
    }),
    computed: {
      rangeText () {
        if(this.dates.length > 0) {
          let dates = this.dates.map(item => this.$moment(item).format('DD/MM/YYYY'))
          return dates.join(', ')
        }
        return ''
      },
    },
    watch: {
      dates: function (val) {
        this.$emit('input', val)
      }
    },
    mounted() {
      this.dates = this.value
    },
  }
</script>
